import React from 'react';
import ReactDOM from 'react-dom/client';

import { createStore } from 'polotno/model/store';
import { unstable_setAnimationsEnabled, unstable_useHtmlTextRender } from 'polotno/config';

import { createProject, ProjectContext } from './project';

import './index.css';
import App from './App';
import AuthGate from './AuthGate';
import './logger';
import { ErrorBoundary } from 'react-error-boundary';

unstable_useHtmlTextRender(true);
unstable_setAnimationsEnabled(false);

const store = createStore({ key: 'V-ACVa-1z9RoJUyOgahN' });
window.store = store;
store.addPage();

const project = createProject({ store });
window.project = project;

const root = ReactDOM.createRoot(document.getElementById('root'));

function Fallback() {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <div style={{ textAlign: 'center', paddingTop: '40px' }}>
        <p>Something went wrong in the app.</p>
        <p>Try to reload the page.</p>
        <p>If it does not work, clear cache and reload.</p>
        <button
          onClick={async () => {
            await project.clear();
            window.location.reload();
          }}
        >
          Clear cache and reload
        </button>
      </div>
    </div>
  );
}

const link = document.createElement("link");
link.href =
  "https://fonts.googleapis.com/css2?family=Assistant:wght@400;600;700;800&display=swap";
link.rel = "stylesheet";
document.head.appendChild(link);

root.render(
  <ErrorBoundary
    FallbackComponent={Fallback}
    onError={(e) => window.Sentry?.captureException?.(e)}
  >
    <ProjectContext.Provider value={project}>
      <AuthGate>
        <App store={store} />
      </AuthGate>
    </ProjectContext.Provider>
  </ErrorBoundary>
);
